var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60671 7.24536C8.54004 7.2387 8.46004 7.2387 8.38671 7.24536C6.80004 7.19203 5.54004 5.89203 5.54004 4.29203C5.54004 2.6587 6.86004 1.33203 8.50004 1.33203C10.1334 1.33203 11.46 2.6587 11.46 4.29203C11.4534 5.89203 10.1934 7.19203 8.60671 7.24536Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27348 9.70797C3.66014 10.788 3.66014 12.548 5.27348 13.6213C7.10681 14.848 10.1135 14.848 11.9468 13.6213C13.5601 12.5413 13.5601 10.7813 11.9468 9.70797C10.1201 8.48797 7.11348 8.48797 5.27348 9.70797Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWhite);
export default __webpack_public_path__ + "static/media/profile_white.1b81aff576ce521143e7f140131d35d7.svg";
export { ForwardRef as ReactComponent };